import React from 'react';
import { string, func, number } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './BookingNotesField.module.css';

/**
 * BookingNotesField — optional notes/special requests textarea for checkout.
 *
 * The value is stored in transaction.protectedData.bookingNote.
 * Both the customer and provider can see it in the transaction page.
 *
 * Usage (in CheckoutPage or OrderPanel, after payment details):
 *   {features.bookingNotes && (
 *     <BookingNotesField
 *       value={bookingNote}
 *       onChange={note => setBookingNote(note)}
 *     />
 *   )}
 *
 * @param {string}   props.value — current note text
 * @param {Function} props.onChange — called with new value
 * @param {number}   [props.maxLength] — max characters (default: 500)
 */
const BookingNotesField = ({ value, onChange, maxLength, className }) => {
  return (
    <div className={classNames(css.root, className)}>
      <label className={css.label}>
        <FormattedMessage id="BookingNotesField.label" />
        <span className={css.optional}>
          {' '}(<FormattedMessage id="BookingNotesField.optional" />)
        </span>
      </label>
      <p className={css.description}>
        <FormattedMessage id="BookingNotesField.description" />
      </p>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        maxLength={maxLength}
        rows={4}
        className={css.textarea}
        placeholder="..."
      />
      <p className={css.charCount}>{value.length}/{maxLength}</p>
    </div>
  );
};

BookingNotesField.defaultProps = { maxLength: 500, className: null };
BookingNotesField.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  maxLength: number,
  className: string,
};

export default BookingNotesField;
